export const HUB_ORDER_STATUS = {
  HUB_WAIT_PAY: 1, // 待支付                      待支付
  HUB_PAYED: 2, // 已支付                         待接单
  HUB_PAYED_NEW: 3, // 已支付                         待接单
  HUB_HAS_ACCEPT: 4, //                          已接单/待出发
  HUB_PASSENGER_GET_ON: 5, // 乘客上车            已上车
  HUB_PASSENGER_GET_OFF: 6, // 乘客下车           已完成
  HUB_AUTO_DONE: 9, // 后台自动完成(未确认下车)     已完成
  HUB_CLOSED: 10, // 已关闭                       已关闭
  HUB_REFUNDING: 11, // 退款中                    退款中
  HUB_HAS_CANCEL: 12, // 已取消                   已取消
  HUB_REFUNDING_FAILD: 13, // 退款失败            退款失败
  HUB_MANAGER_CANCEL: 14, // 管理员取消           退款中
};

export const HUB_ORDER_STATUS_MAP = {
  [HUB_ORDER_STATUS.HUB_WAIT_PAY]: "待支付",
  [HUB_ORDER_STATUS.HUB_PAYED]: "待接单",
  [HUB_ORDER_STATUS.HUB_PAYED_NEW]: "待接单",
  [HUB_ORDER_STATUS.HUB_HAS_ACCEPT]: "待出发",
  [HUB_ORDER_STATUS.HUB_PASSENGER_GET_ON]: "已上车",
  [HUB_ORDER_STATUS.HUB_PASSENGER_GET_OFF]: "已完成",
  [HUB_ORDER_STATUS.HUB_AUTO_DONE]: "已完成",
  [HUB_ORDER_STATUS.HUB_CLOSED]: "已关闭",
  [HUB_ORDER_STATUS.HUB_REFUNDING]: "退款中",
  [HUB_ORDER_STATUS.HUB_HAS_CANCEL]: "已取消",
  [HUB_ORDER_STATUS.HUB_REFUNDING_FAILD]: "退款失败",
  [HUB_ORDER_STATUS.HUB_MANAGER_CANCEL]: "退款中",
};
